<template>
	<div>
		<form class="form-container" @submit.prevent="register" v-if="!savedSuccessful">
		<br/>
		<br/>
		<input 
			:placeholder="$t('name')"
			v-model="firstName" 
			:class="{ 'error-boarder': $v.firstName.$error }" 
			@blur="$v.firstName.$touch()"
			type="text" 
			maxlength="25"
			name="firstName" 
			value />
		<template v-if="$v.firstName.$error">
			<div v-if="!$v.firstName.required" class="errorMessage">{{ $t('firstNameReq') }}</div>
		</template>

		<input 
			:placeholder="$t('surname')"
			v-model="lastName" 
			:class="{ 'error-boarder': $v.lastName.$error }" 
			@blur="$v.lastName.$touch()" 
			type="text"
			maxlength="25"
			name="lastName" 
			value />
		<template v-if="$v.lastName.$error">
			<div v-if="!$v.lastName.required" class="errorMessage">{{ $t('lastNameReq') }}</div>
		</template>

		<input 
			:placeholder="$t('email')"
			v-model="email"  
			:class="{ 'error-boarder': $v.email.$error }" 
			type="email"
			maxlength="40"
			name="email"
			@blur="$v.email.$touch()" 
			value 
		/>
		<template v-if="$v.email.$error">
			<div v-if="!$v.email.required" class="errorMessage">{{ $t('emailReq') }}</div>
		</template>
		<template v-if="$v.email.$error">
			<div v-if="!$v.email.email" class="errorMessage">{{ $t('emailValid') }}</div>
		</template>

		<input 
			:placeholder="$t('contactNo')"
			v-model="contact" 
			:class="{ 'error-boarder': $v.contact.$error }" 
			@blur="$v.contact.$touch()" 
			type="number"
			oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
			maxlength="22"
			name="contact"
			onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57"
			value />
		<template v-if="$v.contact.$error">
			<div v-if="!$v.contact.required" class="errorMessage">{{ $t('contactNoReq') }}</div>
		</template>
		<input 
			class="user-input"
			:placeholder="$t('password')"
			v-model="password"
			:class="{ 'error-boarder': $v.password.$error }" 
			:type="passwordFieldType"
			name="password" 
			@blur="$v.password.$touch()"
			v-on="$listeners"
			v-on:input="errors = null" 
			value
			maxlength="50"
			/>
			<button class="eyeIcon" type="button" @click="switchVisibility">
				<span
					class="input-group-text"
					@click="showPassword = !showPassword">
				<i
					class="fa"
					:class="[showPassword ? 'fa-eye-slash' : 'fa-eye']"
					aria-hidden="true"
				></i>
				</span>
			</button>
		<template v-if="$v.password.$error">
			<div v-if="!$v.password.required" class="errorMessage2">{{ $t('passReq') }}</div>
		</template>
		<template v-if="this.submitted && $v.password.$error">
			<p v-if="password && !$v.password.valid" class="errorMessage2">
				{{ $t('passValid') }}
			</p>
		</template>
		<template v-if="$v.password.$invalid">
			<p v-if="!$v.password.maxLength" class="errorMessage">
				{{ $t('passMaxLength') }}
			</p>
		</template>
		<template v-if="$v.password.$invalid">
			<p v-if="!$v.password.minLength" class="errorMessage">
				{{ $t('passMinLength') }}
			</p>
		</template>
		<div>
			<button :disabled="$v.$invalid && this.isDisabled" class="add-btn" type="submit" name="button">
				{{ $t('createAccount') }}
			</button>
		</div>



		<ul>
			<li v-for="(error, index) in errors" :key="index">{{ error }}</li>
		</ul>
		</form>
		<sweet-modal icon="success" ref="modalSuccess" @close="$bvModal.hide('register-cleaner')">
			{{ $t('accountCreated') }}
		</sweet-modal>
		<sweet-modal icon="error" title="Oh nooo…" ref="modalError">
		{{ $t('errorMsg') }}
		<sweet-button slot="button"> {{ $t('tryAgain') }}</sweet-button>
		</sweet-modal>

	</div>
</template>

<script>

import { required, email, maxLength, minLength  } from "vuelidate/lib/validators";


export default {
  data() {
    return {
      email: '',
      password: '',
      firstName: '',
      lastName: '',
      contact: '',
      role: 'cleaner',
      errors: null,
    //   error: false,
	  submitted: false,
      passwordFieldType: 'password',
      showPassword: false,
  }

  },
  validations: {
    firstName: {
      required,
    },
    lastName: {
      required,
    },
    email: {
      required,
      email,
    },
    contact: {
      required,
    },
    password: {
      required,
	  valid: function (value) {
        const containsUppercase = /[A-Z]/.test(value);
        const containsLowercase = /[a-z]/.test(value);
        const containsNumber = /[0-9]/.test(value);
        const containsSpecial = /[§"()=#?!@$%^&*-/_:;'<>`~{}|]/.test(value);
        return (
            containsUppercase &&
            containsLowercase &&
            containsNumber &&
            containsSpecial
        );
	  },
	  maxLength: maxLength(20),
	  minLength: minLength(8)
    },
  },
  created() {
    this.submitted = true;
    // return this.$v.$touch()
  },
computed: {
    isDisabled() {
      return this.$v.$invalid;
    },
},
  methods: {
    register() {
      this.$store
        .dispatch('createCleaner', {
          email: this.email,
          password: this.password,
          firstName: this.firstName,
          lastName: this.lastName,
          contactNo: this.contact,
          role: this.role
        })
        .then(() => {
          this.$refs.modalSuccess.open()
          this.$emit('success-add-cleaner', '')
          // this.$router.push({ name: 'clientList' }) // automatically redirect to login when user click "register"//
        })
        .catch(err => {
          this.errors = err.response.data.errors
          this.$refs.modalError.open()
        })
	  this.submitted = true;
      this.$v.$touch();
      if (!this.$v.$invalid) {
		// return false; // stop here if form is invalid
        // console.log("form submitted:", this.email);
      }
    },
	switchVisibility() {
      this.passwordFieldType =
        this.passwordFieldType === 'password' ? 'text' : 'password'
    },
  },
}
</script>

<style lang="scss" scoped>
.form-container {
  //position: absolute;
  background: #fff;
  padding: 20px 40px;
  border-radius: 10px;
  box-shadow: 0px 0px 8px 0px #000;
  width: 100%;
}

a:visited {
  color: #2c3e50;
}
.add-btn {
	background: var(--primaryDark);
	color: var(--bright);
	padding: 0.3em;
	border-radius: 5px;
	letter-spacing: 1px;
	width: 70%;
	display: inline;
}

.button,
button {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  background: linear-gradient(to right, $secondary, $secondary-dark);
  font-size: 1.5em;
  color: white;
  border: none;
  width: 80%;
  margin-top: 1em;
  text-transform: uppercase;
  letter-spacing: 0.15em;
  outline: none;
}

button:disabled,
button[disabled]{
  border: 1px solid #999999;
  background-color: #cccccc;
  color: #666666;
  cursor: context-menu;
}

.user-input {
  display: inline-flex;
}

.eyeIcon {
  position: relative;
  justify-content: end !important;
  margin-left: auto;
  top: -58px;
  width: 30px;
//   right: 0px;
  background: none;
}

.input-group-text {
  background: none !important;
  border: none !important;
}

form {
  display: flex;
//   align-items: center;
  flex-direction: column;

  p {
    color: red;
  }
}

input {
  display: block;
  box-sizing: border-box;
  border-style: solid;
  width: 100%;
  height: 2.6em;
  padding: 0.5em;
  margin-top: 2.0em;
  font: 1em 'Lato', Helvetica, sans-serif;
}

h1 {
  margin-top: 0;
}

.errorMessage {
  font-size: 0.8em;
  color: var(--primaryDark);
  text-align: left;
}
.errorMessage2 {
  font-size: 0.8em;
  color: var(--primaryDark);
  text-align: left;
  margin-top:-50px;
}
.error-boarder {
  border: 2px solid var(--primaryDark);
}
@media screen and (max-width: 500px){
  .form-container {
    padding: 15px;
  }
  .add-btn {
  letter-spacing: 0px;
  width: 80%;
}
}
@media screen and (max-width: 330px){
  .add-btn {
  width: 100%;
}
}
</style>
